import { Token } from '@pancakeswap/sdk'
import { CHAIN_ID } from '~/config/constants/chains'
import { SerializedToken } from '~/config/constants/types'
import { parseUnits } from 'viem'

export function serializeToken(token: Token): SerializedToken {
  return {
    chainId: token?.chainId,
    address: token?.address,
    decimals: token?.decimals,
    symbol: token?.symbol,
    name: token?.name,
    projectLink: token?.projectLink,
  }
}

export function deserializeToken(serializedToken: SerializedToken): Token {
  return new Token(
    serializedToken.chainId,
    serializedToken.address,
    serializedToken.decimals,
    serializedToken.symbol,
    serializedToken.name,
    serializedToken.projectLink,
  )
}

export enum GAS_PRICE {
  default = '250', // '0',
  fast = '350', // '0',
  instant = '1000', // '0',
  testnet = '250' // '0' // '10',
}

export const GAS_PRICE_BY_CHAIN = {
  [CHAIN_ID.FANTOM_TESTNET] : {
    // default: parseUnits('250', 'gwei').toString(),
    // fast: parseUnits('350').toString(),
    // instant: parseUnits('1000').toString(),
    // testnet: parseUnits('250').toString()
  }
}


export const GAS_PRICE_GWEI = {
  // default: parseUnits(GAS_PRICE.default, 'gwei').toString(),
  // fast: parseUnits(GAS_PRICE.fast, 'gwei').toString(),
  // instant: parseUnits(GAS_PRICE.instant, 'gwei').toString(),
  // testnet: parseUnits(GAS_PRICE.testnet, 'gwei').toString(),
}
